<div #modalLoading id="modalLoading" tabindex="0" (blur)="modalLoading.focus()">
  <em class="fa fa-spinner fa-pulse fa-3x fa-fw" style="position: relative; top: 50%; left: 50%; color: #00968c;"></em>
</div>
